import {
  getFirestore,
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  query,
  where,
} from 'firebase/firestore';

class Firestore {
  constructor(app, helpers) {
    this.root = helpers;
    this.instance = getFirestore(app);
    this.profilesCollection = collection(this.instance, 'profiles');
    this.propertiesCollection = collection(this.instance, 'properties');
    this.tenanciesCollection = collection(this.instance, 'tenancies');
    this.paymentsCollection = collection(this.instance, 'payments');
  }

  destroy() {
    this.instance = null;
    this.profilesCollection = null;
  }

  loadDoc(path) {
    return getDoc(doc(this.instance, path));
  }
  // Profile
  async getProfileFull(uid) {
    const [profile, profileAccount] = await Promise.all([
      this.getProfile(uid),
      this.getProfileAccount(uid),
    ]);

    console.log('profile snapshot', profile);

    return profile.exists() ? { profile, profileAccount } : null;
  }

  async createProfileFull(profile, profileAccount) {
    return Promise.all([
      this.createProfile(profile),
      this.createProfileAccount(profileAccount),
    ]);
  }

  getProfile(id) {
    console.log('getProfile', id);
    console.log(this.profilesCollection);
    return getDoc(doc(this.instance, this.profilesCollection.path, id));
  }

  getProfileAccount(id) {
    console.log('getProfileAccount', id);
    console.log(this.profilesCollection);

    // return this.profilesCollection.doc(`/${id}/account/public`).get();
    return getDoc(
      doc(this.instance, this.profilesCollection.path, `/${id}/account/public`)
    );
  }

  createProfile(profile) {
    // return this.profilesCollection.doc(profile.profileUid).set(profile);
    return setDoc(
      doc(this.instance, this.profilesCollection.path, profile.profileUid),
      profile
    );
  }

  createProfileAccount(profileAccount) {
    return setDoc(
      doc(
        this.instance,
        this.profilesCollection.path,
        `/${profileAccount.profileUid}/account/public`
      ),
      profileAccount
    );
  }

  // Notices
  getUserNoticesRef() {
    return collection(
      this.instance,
      `/profiles/${this.root.getCurrentUserUid()}/notices`
    );
    // return this.profilesCollection.doc(
    //   `/${this.root.getCurrentUserUid()}/notices`
    // );
  }

  getUserNotices() {
    return getDocs(this.getUserNoticesRef());
  }

  getNoticeRef(noticeUid, profileUid) {
    return doc(
      this.instance,
      `/profiles/${this.root.getCurrentUserUid()}/notices/${noticeUid}`
    );
  }

  markNoticeAsViewed(uid) {
    // return collection(
    //   this.instance,
    //   `/profiles/${this.root.getCurrentUserUid()}/notices`
    // )
    //   .doc(uid)
    //   .update({ hasViewed: true });
    return setDoc(this.getNoticeRef(uid), { hasViewed: true }, { merge: true });
  }

  // Properties
  getUserPropertiesRef(filters) {
    return query(
      this.propertiesCollection,
      where('landlordUid', '==', this.root.getCurrentUserUid()),
      where('hasDeleted', '==', false)
    );
  }

  getUserProperties(query) {
    return getDocs(this.getUserPropertiesRef(query));
  }

  getSubscriptionRef() {
    return doc(
      this.instance,
      `/subscriptions/${this.root.getCurrentUserUid()}`
    );
  }

  getLandlordStatsRef() {
    return doc(
      this.instance,
      `/profiles/${this.root.getCurrentUserUid()}/landlord/stats`
    );
  }

  getPropertiesRef(propertiesUids) {
    // return this.propertiesCollection
    //   .where('propertyUid', 'in', propertiesUids)
    //   .where('hasDeleted', '==', false);
    return query(
      this.propertiesCollection,
      where('propertyUid', 'in', propertiesUids),
      where('hasDeleted', '==', false)
    );
  }

  getProperties(propertiesUids) {
    return getDocs(this.getPropertiesRef(propertiesUids));
  }

  searchProperties(filters) {
    // return this.propertiesCollection.where('hasDeleted', '==', false).get();

    return getDocs(
      query(this.propertiesCollection, where('hasDeleted', '==', false))
    );
  }

  getProperty(propertyUid) {
    return getDoc(this.getPropertyRef(propertyUid));
  }

  getPropertyRef(propertyUid) {
    // return this.propertiesCollection.doc(propertyUid);
    return doc(this.instance, this.propertiesCollection.path, propertyUid);
  }

  getPropertyDataRef(propertyUid, dataUid) {
    return doc(this.instance, `/properties/${propertyUid}/data/${dataUid}`);
  }

  getPropertyInventoryItemsRef(propertyUid) {
    return collection(
      this.instance,
      `/properties/${propertyUid}/inventoryItems`
    );
  }

  getPropertyInventoryItems(propertyUid) {
    return getDocs(this.getPropertyInventoryItemsRef(propertyUid));
  }

  getPropertyInventoryRef(propertyUid, inventoryUid) {
    return doc(
      this.instance,
      this.propertiesCollection.path,
      `/${propertyUid}/inventoryItems/${inventoryUid}`
    );
  }

  getPropertyInventory(propertyUid, inventoryUid) {
    return getDoc(this.getPropertyInventoryRef(propertyUid, inventoryUid));
  }

  getTenancyRef(tenancyUid) {
    // return this.tenanciesCollection.doc(`/${tenancyUid}`);
    return doc(this.instance, this.tenanciesCollection.path, tenancyUid);
  }

  getTenanciesRef(tenancyUids) {
    // return this.tenanciesCollection.where('tenancyUid', 'in', tenancyUids);
    return query(
      this.tenanciesCollection,
      where('tenancyUid', 'in', tenancyUids)
    );
  }

  getTenancyTenantsRef(tenancyUid) {
    return collection(this.instance, `/tenancies/${tenancyUid}/tenants`);
  }

  getUserPaymentsRef() {
    // return this.paymentsCollection.where(
    //   'accessUids',
    //   'array-contains',
    //   this.root.getCurrentUserUid()
    // );
    //
    return query(
      this.paymentsCollection,
      where('accessUids', 'array-contains', this.root.getCurrentUserUid())
    );
  }

  getTenancyPaymentsRef(tenancyUid) {
    // return this.getUserPaymentsRef().where('tenancyUid', '==', tenancyUid);

    return query(
      this.paymentsCollection,
      where('accessUids', 'array-contains', this.root.getCurrentUserUid()),
      where('tenancyUid', '==', tenancyUid)
    );
  }

  getTenancyTenantRef(tenancyUid, tenantUid) {
    return doc(this.instance, `/tenancies/${tenancyUid}/tenants/${tenantUid}`);
  }

  getTenancyNoticesRef(tenancyUid) {
    return collection(this.instance, `/tenancies/${tenancyUid}/notices`);
  }

  getVerificationRequestRef() {
    return doc(
      this.instance,
      `/verificationRequests/${this.root.getCurrentUserUid()}`
    );
  }
}

export default Firestore;
